import axios from 'axios'
import exceptionHandler from '@/common/exception-handler'

export function isTOLEnabled(location) {
  return !location || !location.tolSettings || location.tolSettings.isAuth
}

export function getCutoverStatus ({ tenantId, tolUrl }) {
  const url = tolUrl + '/slice/cutover?tccId=' + tenantId
  return axios({
    method: 'get',
    url,
    withCredentials: false
  })
    .then(r => r.data)
    .catch(err => { exceptionHandler.parse(err) })
}

export function triggerCutover ({ tenantId, tolUrl }) {
  const url = tolUrl + '/slice/cutover'
  return axios({
    method: 'post',
    url,
    withCredentials: false,
    data: { tccId: tenantId }
  })
    .then(r => r.data)
    .catch(err => { exceptionHandler.parse(err) })
}

export function deleteCreditTokens ({ tenantId, tolUrl }) {
  return axios.delete(`${tolUrl}/slice/tcc/creditCard/${tenantId}`)
    .then(res => res.data)
}
